export default [
    {
        path: '/sysIndex',
        name: 'Partner',
        component: ()=>import('@/views/index/index.vue'),
        meta: {
            title: '合伙人管理'
        },
        children: [
           {
                path: 'partner',
                name: 'partner',
                component: ()=>import('@/views/system/partner/index.vue'),
                meta: {
                    title: '合伙人列表'
                }
           },
        ]
    },
    {
        path: '/sysIndex',
        name: 'Store',
        component: ()=>import('@/views/index/index.vue'),
        meta: {
            title: '门店管理'
        },
        children: [
           {
                path: 'storeList',
                name: 'storeList',
                component: ()=>import('@/views/system/store/index.vue'),
                meta: {
                    title: '门店列表'
                }
           },
           {
                path: 'order',
                name: 'order',
                component: ()=>import('@/views/system/store/order.vue'),
                meta: {
                    title: '交易流水'
                }
            },
            {
                path: 'reconciliation',
                name: 'reconciliation',
                component: ()=>import('@/views/system/store/reconciliation.vue'),
                meta: {
                    title: '门店对账查询'
                }
            },
            
        ]
    },
    {
        path: '/sysIndex',
        name: 'Order',
        component: ()=>import('@/views/index/index.vue'),
        meta: {
            title: '交易统计'
        },
        children: [
           {
                path: 'manage',
                name: 'manage',
                component: ()=>import('@/views/system/order/index.vue'),
                meta: {
                    title: '商户订单管理'
                }
           },
           {
                path: 'orderTotal',
                name: 'orderTotal',
                component: ()=>import('@/views/system/order/total.vue'),
                meta: {
                    title: '商户交易统计'
                }
            },
        ]
    },
    {
        path: '/sysIndex',
        name: 'Income',
        component: ()=>import('@/views/index/index.vue'),
        meta: {
            title: '分红管理'
        },
        children: [
           {
                path: 'withdraw',
                name: 'withdraw',
                component: ()=>import('@/views/system/income/index.vue'),
                meta: {
                    title: '提现记录'
                }
           },
           {
                path: 'totalList',
                name: 'totalList',
                component: ()=>import('@/views/system/income/total.vue'),
                meta: {
                    title: '结算记录'
                }
            },
        ]
    },
    {
        path: '/sysIndex',
        name: 'Advert',
        component: ()=>import('@/views/index/index.vue'),
        meta: {
            title: '广告管理'
        },
        children: [
           {
                path: 'poster',
                name: 'poster',
                component: ()=>import('@/views/system/poster/index.vue'),
                meta: {
                    title: '广告列表'
                }
           },
        ]
    },
]
    
